import {useQuery} from '@tanstack/react-query'

import {queries} from '../../queries'

export const usePersistedRmcOrder = (siteNumber: string) => {
  return useQuery({
    queryKey: ['persistedRmcOrder', siteNumber],
    queryFn: () => queries.persistedRmcOrder(siteNumber),
    enabled: !!siteNumber
  })
}
